export default {
  'meta': {
    'langName': 'TURKISH',
    'lang': 'Türkçe'
  },
  'title': 'ÜRÜN GERİ ÇAĞIRMA: BTWIN SD500E VEYA MD500E ELEKTRİKLİ SCOOTER',
  'description': 'Merhaba,\n\nBTWIN marka SD500E veya MD500E elektrikli scooter satın aldığınız için teşekkür ederiz.\n\nGüvenliğiniz bizim önceliğimizdir, lütfen aşağıdaki bilgileri dikkatlice okuyunuz.\n\nTitiz kalite kontrol prosedürlerimize rağmen, BTWIN marka SD500E ve MD500E elektrikli scooterlarda bir güvenlik kusuru tespit etmiş bulunmaktayız. Yoğun kullanım, kadro (gövde) ile gidon boğazının birleştiği yerde bir çatlak oluşmasına neden olabilmektedir. Bu kusur, söz konusu birleşim yerinin kırılmasına yol açarak kullanıcı için düşme riski oluşturabilir.\n\nÜrününüz için size bir güvenlik çözümü sunabilmemiz adına aşağıdaki soruları yanıtlamanızı rica ediyoruz.\n\nYaşanan her türlü olumsuzluk için özür diler, bize duyduğunuz güven için teşekkür ederiz.\n\nDECATHLON',
  'emailConfirmation': {
    'title': 'Size en doğru bilgiyi sağlayabilmemiz için lütfen e-posta adresinizi ve ikamet ettiğiniz ülkeyi seçiniz:'
  },
  'fields': {
    'country': 'Ülke',
    'address': 'E-posta Adresi',
    'email': 'E-posta Adresi',
    'phonePrefix': 'Telefon numarası kodu',
    'phone': 'Telefon numarası',
    'validations': {
      'phoneOrEmail': 'Lütfen en az bir e-posta adresi veya bir telefon numarası belirtin.',
      'email': 'Lütfen geçerli bir e-posta adresi girin',
      'phone': 'Lütfen geçerli bir telefon numarası girin',
      'selectAddress': 'Lütfen listeden eksiksiz bir adres seçin (bina/kapı numarası, cadde/sokak adı ve şehir). ',
      'incompleteAddress': 'Adres mutlaka kapı numarası, cadde/sokak adı ve şehir bilgilerini içermelidir.En azından kapı numarasını ve caddeyi/sokağı yazın, ardından çıkan önerilerden birini seçin.'
    },
    'firstName': 'Soyisim',
    'lastName': 'İsim',
    'deliveryAddress': 'Paketin gönderileceği adres',
    'additionalAddress': 'Ek adres detayları',
    'city': 'Şehir',
    'zip': 'Posta Kodu',
    'readConfirmation': 'İletişim bilgilerimin doğru olduğunu onaylıyor, sunulan şartları okuduğumu beyan ediyor ve bunlara uymayı kabul ediyorum.',
    'choose': 'Seçiniz',
    'required': 'Bu alan zorunludur',
    'deliveryAddressHelp': 'Bina/kapı numaranızı ve cadde/sokak adınızı girin, ardından listeden eksiksiz bir adres seçin.',
    'streetOnlyHint': 'Lütfen bir cadde numarası ekleyin'
  },
  'ownerCheck': {
    'title': '"Hâlâ bir veya birden fazla BTWIN SD500E ve MD500E elektrikli scooter sahibi misiniz?'
  },
  'yes': 'EVET',
  'no': 'HAYIR',
  'ownerChanged': {
    'title': 'Eğer potaya artık sahip değilseniz, mevcut sahibinin/sahiplerinin iletişim bilgilerini biliyor musunuz?',
    'confirmation': 'Sayın Müşterimiz,\n\nBu kalite girişimine katılımınız için teşekkür ederiz.\n\nYaşanan rahatsızlıktan dolayı özür diler, güveniniz için teşekkür ederiz.\n\nDECATHLON'
  },
  'recall': {
    'title': 'Lütfen BTWIN SD500E ve MD500E elektrikli scooter adedini belirtiniz.',
    'descriptionSd500': 'SD500E Elektrikli Scooter: [ Adet Giriniz ]',
    'descriptionEmd500e': 'MD500E Elektrikli Scooter: [ Adet Giriniz ]',
    'modelNumberHelp': 'Model numarasını (SD500E veya MD500E) aşağıda gösterildiği gibi scooterınızın alt kısmında bulabilirsiniz.',
    'quantity': 'Adet',
    'confirmation': 'Bu formu doldurduğunuz için teşekkür ederiz. Talebiniz başarıyla kaydedilmiştir.\r\n\r\nOnarımı gerçekleştirebileceğiniz tarih konusunda sizi en geç 20 gün içinde bilgilendireceğiz.\r\n\r\nHarika bir gün geçirmeniz dileğiyle,\r\n\r\nDECATHLON'
  },
  'repair': {
    'title': 'Sizin Katılımınızla Onarım',
    'description': 'Ürünü kullanmayı bırakmanızı rica ediyoruz.\n\nScooterınızı güvenli hale getirebilmeniz için evinize bir tamir kiti ve talimatlar gönderilecektir. Bu kit tarafınıza ücretsiz olarak gönderilecek olup, montajı hızlı ve kolaydır.\n\nBilgilerinizin alınmasını takiben, tamirin ne zamandan itibaren mümkün olacağını belirlemek üzere en geç 20 gün içinde sizinle iletişime geçeceğiz. Sizi memnun etmek adına bu süreleri kısaltmak için her türlü çabanın gösterileceğinden emin olabilirsiniz.',
    'videoLink': 'Video Linki',
    'store': 'Dosya Linki',
    'kitLabel': 'Full Tamir Kiti',
    'docLabel': 'Tamir Talimatları',
    'callToAction': 'Ücretsiz tamir kitinizi almak için buraya tıklayın',
    'infoConfirmation': 'Lütfen detayları kontrol edin.',
    'validateConfirmation': 'Onayla',
    'backConfirmation': 'Geri Dön'
  },
  'repairRequest': {
    'title': 'Tamir kitinizi alabilmek için lütfen aşağıdaki bilgileri giriniz:'
  },
  'form': {
    'submit': 'Sonraki'
  },
  'status': 'Translation validated by COUNTRY'
} as const
